import React, { useEffect, useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../firebase/config';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import { Button } from 'flowbite-react'

const Login: React.FC = () => {
  const { user, loading } = useAuthContext();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // ✅ Redirect if already logged in
  useEffect(() => {
    if (!loading && user) {
      navigate('/dashboard');
    }
  }, [user, loading, navigate]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/dashboard'); // ✅ Also redirect after login success
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div className='p-4 max-w-md mx-auto text-darkblue'>
      <h2 className='text-xl mb-4 text-darkblue'>Login</h2>
      <form onSubmit={handleLogin} className='space-y-4'>
        <input
          type='email'
          placeholder='Email'
          className='w-full p-2 border'
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <input
          type='password'
          placeholder='Password'
          className='w-full p-2 border'
          value={password}
          onChange={e => setPassword(e.target.value)}
        />
        {error && <p className='text-red-500 text-sm'>{error}</p>}
        <Button pill type='submit' className='bg-lightblue text-white px-4 py-2'>
          Login
        </Button>
      </form>
    </div>
  );
};

export default Login;
